// extracted by mini-css-extract-plugin
export default {"root":"classes_root__ecieV","question":"classes_question__WX1WJ","actions":"classes_actions__WIwbP"};